import React from 'react';
import { Box } from '@mui/material';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { BannerTemplateRenderer } from './BannerTemplates';

const BannerSlider = ({ sliders }) => {
    const hasMultipleSlides = sliders && sliders.length > 1;

    const settings = {
        dots: false,
        infinite: hasMultipleSlides,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: hasMultipleSlides,
        autoplaySpeed: 3000,
        arrows: false,
        dotsClass: 'slick-dots',
    };

    return (
        <Slider {...settings} width="100%">
            {sliders?.map((slide, index) => (
                <Box key={index} sx={{ px: { xs: 0, md: 1 } }}>
                    <BannerTemplateRenderer slide={slide} />
                </Box>
            ))}
        </Slider>
    );
};

export default BannerSlider;